<template>
  <div class="Reward" :style="inputColor">
    <div class="text">
      <div class="title fs24">{{reward.title}}</div>
      <div class="content fs18">{{reward.content}}</div>
    </div>
  </div>
</template>

<script>
 /* import Arrow from '@/assets/image/frontpage/arrow-bottom.png';*/
 export default {
   name: 'Reward',
   props: ['reward'],
   computed: {
     imgWidth () {
       return this.$store.state.mediaPhone? '2vw': '1.35vw'
     },
     arrow () {
       return Arrow
     },
     inputColor () {
       return {
         'border': '1px solid #bbb'
       }
     }
   },
   components: {
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .Reward{
   width: 18vw;
   height: 8vw;
   padding-top: 0.5vw;
   padding-bottom: 0.5vw;
   margin-bottom: 2vw;
   display: flex;
   align-items: flex-start;
   border-radius: 5px;
 }
 .icon{
   /* width: 5em;
      height: 5em; */
   /* border: 1px solid black; */
   font-size: 4em;
   line-height: 96px;
   margin-left: 1.5vw;
   margin-right: 2vw;
   /* margin-left: 1em;
      margin-right: 2em; */
 }
 .text{
   display: flex;
   width: 100%;
   flex-direction: column;
   margin-top: 0.6vw;
 }
 .title {
   line-height: 42px;
   font-weight: bold;
   text-align: center;
 }
 .content{
   text-align: center;
   margin-left: 15px;
   margin-right: 15px;
   color: #444;
 }


 @media (min-width: 320px) and (max-width: 480px) {
   .time{
     width: 12vw;
     height: 7.73vw;
     border-radius: 0.5vw;
   }
   .time .year{
     font-size: 1.6vw;
   }
   .time .date{
     font-size: 2.1vw;
   }
   .event{
     width: 13.38vw;
     height: 9.28vw;
   }
   .event .arrow{
     margin-top: 1.25vw;
   }
   .event .main{
     margin-top: 0.625vw;
     font-size: 2.08vw;
   }
   .event .sub{
     margin-top: 0.4vw;
     font-size: 1.7vw;
   }


 }

</style>
